module.exports = __webpack_public_path__ + "static/media/prize-3.468d0760.png";